var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthorFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#167092"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 7.05475V10.9285C15.1666 11.5488 14.7471 12.1032 14.1249 12.3144H14.1178C13.6843 12.4662 13.2368 12.5388 12.7893 12.5388C12.1182 12.5388 11.4539 12.3738 10.8526 12.0637L10.8107 12.0373C10.3563 11.8063 9.86676 11.6875 9.37731 11.6875C9.04864 11.6875 8.71305 11.7402 8.39145 11.8525C8.2795 11.892 8.16774 11.9052 8.04881 11.9052V15.8384C8.04881 16.1155 7.81813 16.3333 7.52441 16.3333C7.23776 16.3333 7 16.1156 7 15.8384L7.00018 10.9285V7.05469C7.00018 6.43439 7.4197 5.87334 8.04194 5.66228C8.47549 5.51704 8.92999 5.44446 9.37742 5.44446C10.0486 5.44446 10.7128 5.60287 11.3141 5.91959L11.356 5.93943C11.8104 6.17708 12.3 6.29573 12.7894 6.29573C13.1181 6.29573 13.4466 6.24299 13.7682 6.13074L13.7753 6.13066H13.7824C13.8943 6.09108 14.013 6.07125 14.125 6.07125C14.4047 6.07125 14.6634 6.17691 14.8522 6.35498C15.0409 6.52672 15.1666 6.77751 15.1666 7.05475ZM14.1179 10.9285V7.06123C13.6844 7.21305 13.2369 7.28564 12.7894 7.28564C12.1183 7.28564 11.454 7.12065 10.8527 6.81051L10.8108 6.78409C10.3564 6.55311 9.86687 6.43428 9.37742 6.43428C9.04874 6.43428 8.71315 6.48703 8.39155 6.59927C8.18876 6.66519 8.04892 6.85009 8.04892 7.05466V10.9219C8.4824 10.7701 8.9299 10.6975 9.37742 10.6975C10.0485 10.6975 10.7128 10.8625 11.3141 11.1727L11.356 11.1925C11.8104 11.4302 12.3 11.5488 12.7894 11.5488C13.1181 11.5488 13.4537 11.4961 13.7753 11.3838H13.7823C13.9781 11.3113 14.1179 11.1331 14.1179 10.9285Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorFlag);
export default __webpack_public_path__ + "static/media/author_flag.ef5b6f471d15e7749b634a2f7ca44cae.svg";
export { ForwardRef as ReactComponent };